<template>
  <div :class="{formGroup: true, isRequired: itemSetting.action.isRequired}">
    <div class="label" :style="labelStyle">
      <p>{{itemSetting.action.label[lang]}}</p>
      <span v-if="passed !== null && passed === false" class="validateMessage">({{locale.required}})</span>
    </div>
    <input type="text" class="input" :style="valueStyle" v-model="value">
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Input',
  props: [
    'id',
    'itemSetting',
    'lang',
    'locale',
    'storageData',
    'getSubmitData'
  ],
  computed: {
    labelStyle () {
      const fontSize = this.itemSetting.action.labelFontSize
      return {
        ...fontSize && fontSize !== 'default' && {
          fontSize: `${fontSize}px`
        }
      }
    },
    valueStyle () {
      const fontSize = this.itemSetting.action.valueFontSize
      return {
        ...fontSize && fontSize !== 'default' && {
          fontSize: `${fontSize}px`
        }
      }
    },
    value: {
      get () {
        const data = this.getSubmitData && this.getSubmitData.find(x => x.id === this.id) ? this.getSubmitData.find(x => x.id === this.id).value : ''
        return data
      },
      set (value) {
        const passed = !this.itemSetting.action.isRequired ? null : value !== ''
        const translate = this.itemSetting.action.translate
        const data = {
          id: this.id,
          value: value,
          passed: passed,
          ...translate && {
            translate: translate
          }
        }
        this.$emit('setValue', data)
      }
    },
    findValue () {
      return this.getSubmitData && this.getSubmitData.find(x => x.id === this.id) && this.getSubmitData.find(x => x.id === this.id).value
    },
    passed () {
      return this.getSubmitData && this.getSubmitData.find(x => x.id === this.id)
        ? this.getSubmitData.find(x => x.id === this.id).passed
        : null
    }
  },
  data () {
    return {
      message: 'is required'
    }
  },
  methods: {
    setSubmitData (value) {
      const passed = !this.itemSetting.action.isRequired ? null : value !== ''
      const translate = this.itemSetting.action.translate
      const data = {
        id: this.id,
        value: value,
        passed: passed,
        ...translate && {
          translate: translate
        }
      }
      this.$emit('setValue', data)
    }
  }
}
</script>
